const config = {
  defaultPage: '/migration',
}

export default config
